import { apiRequest } from '@department-of-veterans-affairs/platform-utilities/api';
import environment from 'platform/utilities/environment';
import moment from 'moment';
import { getStatus, extractMessages } from '../helpers';
import {
  CH31_CASE_MILESTONES_FETCH_FAILED,
  CH31_CASE_MILESTONES_FETCH_STARTED,
  CH31_CASE_MILESTONES_FETCH_SUCCEEDED,
} from '../constants';
import { fetchCh31CaseStatusDetails } from './ch31-case-status-details';

export function submitCh31CaseMilestones({
  milestoneCompletionType,
  postpone = false,
  user,
}) {
  return dispatch => {
    dispatch({ type: CH31_CASE_MILESTONES_FETCH_STARTED });

    const url = `${environment.API_URL}/vre/v0/ch31_case_milestones`;
    let milestoneSubmissionUser = '';

    if (user?.profile?.userFullName?.last) {
      milestoneSubmissionUser += user.profile.userFullName.last;
    }

    if (user?.profile?.userFullName?.first) {
      milestoneSubmissionUser += `, ${user.profile.userFullName.first}`;
    }

    return apiRequest(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        milestones: [
          {
            milestoneType: milestoneCompletionType,
            isMilestoneCompleted: true,
            milestoneCompletionDate: moment().format('YYYY-MM-DD'),
            postpone,
            milestoneSubmissionUser,
          },
        ],
      }),
    })
      .then(response => {
        dispatch({
          type: CH31_CASE_MILESTONES_FETCH_SUCCEEDED,
          payload: response.data,
        });

        dispatch(fetchCh31CaseStatusDetails());
      })
      .catch(errOrResp => {
        const status = getStatus(errOrResp);
        const messages = extractMessages(errOrResp);

        dispatch({
          type: CH31_CASE_MILESTONES_FETCH_FAILED,
          error: {
            status: status ?? null,
            messages: messages.length
              ? messages
              : [errOrResp?.message || 'Network error'],
          },
        });
      });
  };
}
